import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { useAppManager } from 'core/hooks';
import { Button } from 'components';
import { Table } from 'libs/connection';
import { SortByAction, FilterByAction } from 'libs/connection/actions';

import { Link } from 'core/routing';
import { CenteredButtonWrapper } from 'apps/components/shared';
import { PortalLink } from 'apps/client/components/PortalLink';
import { IntermediatorSwitcherDescription } from 'apps/client/components/ChangePortalBanner';
import { useClientStore, useRouterStore } from 'apps/hooks';

import { OrderConnManager } from './connManager';

const OpenOrderButton = ({ node }) => (
  <PortalLink
    name='order'
    params={{ orderId: node.decimalId }}
    openTab={{ title: `${node.decimalId}`, iconType: 'order' }}
  >
    <Button
      size='small'
      text='Open'
      outline
      icon='arrow_right'
      iconPosition='right'
    />
  </PortalLink>
);

const OrderList = observer(({ maxItems }) => {
  const clientStore = useClientStore();
  const routerStore = useRouterStore();
  const conn = useAppManager(OrderConnManager, null);

  const actions = {
    leftActions: [SortByAction, FilterByAction],
    rightActions: [
      routerStore.route.name !== 'workspace' &&
        IntermediatorSwitcherDescription,
    ].filter(Boolean),
  };

  let bottomButton = null;
  let numRows = conn?.nodes?.length;
  if (!numRows) numRows = 0;
  if (maxItems && maxItems <= numRows) {
    const params = { spacePath: clientStore.activeSpace?.path };
    bottomButton = (
      <CenteredButtonWrapper>
        <Link name='workspace.orders' params={params}>
          <Button
            size='default'
            variant='primary'
            outline
            text='Show all'
            icon='arrow_right'
            iconPosition='right'
          />
        </Link>
      </CenteredButtonWrapper>
    );
  }

  return (
    <div id='tableWrapper' className='mt-2'>
      <Table
        {...{
          contentName: 'Orders',
          columns: conn.finalColumns,
          conn,
          actions,
          maxRows: maxItems,
          subRowsAccessor: 'quote.productQuotes',
          RowActionButtons: OpenOrderButton,
        }}
      />
      {bottomButton}
    </div>
  );
});

OrderList.propTypes = {
  routerStore: PropTypes.object,
};

export default OrderList;
